import 'vue-plyr/dist/vue-plyr.css';

window.Vue.component('banner-small', require('./components/banners/banner-small.vue'));
window.Vue.component('banner-video-home', require('./components/banners/banner-video-home'));
window.Vue.component('banner-wide-home', require('./components/banners/banner-wide-home'));
window.Vue.component('list-category-products', require('./components/products/list-category-products'));
window.Vue.component('list-products-by-category', require('./components/products/list-products-by-category'));
window.Vue.component('list-products-specials-custom', require('./components/products/list-products-specials-custom'));
window.Vue.component('list-small-products', require('./components/products/list-small-products'));
// window.Vue.component('opt-in', require('./components/opt-in/opt-in'));
window.Vue.component('subcategories', require('./components/subcategories'));
window.Vue.component('banner-wide-home-offline', require('./components/banners/banner-wide-home-offline'));
window.Vue.component('banner-list-lites', require('./components/banners/banner-list-lites.vue'));

const rootComponents = new Vue({
    el: '#root-category'
});


// WEBPACK FOOTER //
// ./resources/site/js/category.js